import { API_BASE_URLS, PRODUCT_API_BASE_URL } from '../../../shared/constants/apiConstants';
import apiClient from '../../../shared/services/apiHelper';
import { getOuId } from '../../../shared/utils/authStorage';

export const equipmentService = {
  // Fetch all equipment with pagination and filters
  fetchEquipment: async (page = 1, limit = 10, filters = {},expand) => {
    const ouId = getOuId();
    try {
      let url = `/equipment?ouId=${ouId}`;
      
      // Add pagination parameters
      url += `&page_number=${page}`;
      
      if (filters.sortField) {
        url += `&sort=${filters.sortField}`;
      }
      if (filters.searchQuery) {
        url += `&name=${encodeURIComponent(filters.searchQuery)}`;
      }
      if (filters.productId) {
        url += `&product_id=${filters.productId}`;
      }
      if (filters.makeId) {
        url += `&make_id=${filters.makeId}`;
      }
      if (filters.modelId) {
        url += `&model_id=${filters.modelId}`;
      }
      if(expand){
        url += `&expand=${expand}`;
     
      }
     
      const response = await apiClient.get(url);
      return response;
      
    } catch (error) {
      console.error('Error fetching equipment:', error);
      throw error;
    }
  },

  // Search products
  searchProducts: async (searchQuery = '') => {
    const ouId = getOuId();
    try {
      let url = `/product/search?ouId=${ouId}`;
      
      if (searchQuery) {
        url += `&name=${encodeURIComponent(searchQuery)}`;
      }
      
      const response = await apiClient.get(url);
      return response.data;
      
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },

  // Search makes
  searchMakes: async (searchQuery = '', productId = '') => {
    console.log(`product id in make is ${productId}`);
    const ouId = getOuId();
    try {
      let url = `/make/search?`;

        url += `&product_id=${productId}`;
      const response = await apiClient.post(url,{
        ouId:ouId,
        make_name:searchQuery,
      },);
      return response.data;
      
    } catch (error) {
      console.error('Error searching makes:', error);
      throw error;
    }
  },

  // Search models
  searchModels: async (searchQuery = '', makeId = '',productId = '') => {
    console.log(`product id is ${productId}`);
    const ouId = getOuId();
    try {
      let url = `/model/search?&product_id=${productId}`;
      const response = await apiClient.post(url,{
        ouId:ouId,
        make_id:makeId,
        model_name:searchQuery
      });
      return response.data;
      
    } catch (error) {
      console.error('Error searching models:', error);
      throw error;
    }
  },

  // Create new equipment
  createEquipment: async (equipmentData) => {
    try {
      const response = await apiClient.post(`/equipment`, equipmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating equipment:', error);
      throw error;
    }
  },

  // Fetch product details
  fetchProductDetails: async () => {
    try {
      const response = await fetch(`${PRODUCT_API_BASE_URL}/product/details`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch product details');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching product details:', error);
      throw error;
    }
  },

  // Fetch client details
  fetchClientDetails: async () => {
    try {
      const response = await fetch(`${PRODUCT_API_BASE_URL}/client/details`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch client details');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching client details:', error);
      throw error;
    }
  }
};